<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <WorkSheet></WorkSheet>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import WorkSheet from "../../../components/StudentPanel/WorkSheet/workSheet.vue";

export default {
  name: "StudentWorkSheet",
  components: { WorkSheet, BreadCrumbs },
  data() {
    return {
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: this.$route.meta.title,
          disabled: true,
          to: {
            name: this.$route.name,
          },
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>